import { useState, useCallback } from 'react';
import { Col, Button } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import ClientPluginList from './ClientPluginList/ClientPluginsList';
import PluginClientManifestModal from '../../../../../Modals/MissionControl/ClientManifest/PluginClientManifestModal';

const ClientPluginsInfo = ({
    instanceId,
    canEditPlugins,
    clientPlugins,
    pluginStatuses,
    refreshManifest,
}) => {
    const [addPluginModalOpen, setaddPluginModalOpen] = useState(false);

    const toggleAddingPlugin = useCallback(
        () => setaddPluginModalOpen(!addPluginModalOpen),
        [addPluginModalOpen]
    );

    return (
        <>
            <PluginClientManifestModal
                isOpen={addPluginModalOpen}
                refreshManifest={() => refreshManifest()}
                toggle={toggleAddingPlugin}
            />
            <Col lg="12" md="12" sm="12" className="p-0">
                <section className="content">
                    <div className="plugincard bg-gradient-primary">
                        <div className="card-header">
                            <h3 className="plugincard-title text-light">
                                Client Manifest Plugins
                            </h3>
                        </div>
                        <div
                            className="plugincard-body table-responsive p-0"
                            style={{ minHeight: '200px', maxHeight: '300px' }}>
                            <ClientPluginList
                                instanceId={instanceId}
                                plugins={clientPlugins}
                                canEditPlugins={canEditPlugins}
                                pluginStatuses={pluginStatuses}
                                refreshManifest={() => refreshManifest()}
                            />
                        </div>
                        <div className="plugincard-footer">
                            {canEditPlugins && (
                                <Button
                                    className="mx-2"
                                    color="primary border"
                                    onClick={toggleAddingPlugin}>
                                    <FontAwesomeIcon icon={faPlus} />
                                    &emsp;Add New Plugin
                                </Button>
                            )}
                        </div>
                    </div>
                </section>
            </Col>
        </>
    );
};

export default ClientPluginsInfo;
